const LANG = {
  default: 'en',
  list: [
    { c: 'en', n: 'English', u: true, t: true },
    { c: 'ko', n: '한국어', u: true, t: true },
    { c: 'ja', n: '日本語', u: false, t: false },
    { c: 'zh-CN', n: '简体中文', u: false, t: false },
    { c: 'zh-TW', n: '繁體中文', u: false, t: false },
    { c: 'da', n: 'dansk', u: false, t: false },
    { c: 'nl', n: 'Nederlands', u: false, t: false },
    { c: 'fr', n: 'français', u: false, t: false },
    { c: 'de', n: 'Deutschland', u: false, t: false },
    { c: 'hi', n: 'हिंदी', u: false, t: false },
    { c: 'id', n: 'bahasa Indonesia', u: false, t: false },
    { c: 'ms', n: 'Melayu', u: false, t: false },
    { c: 'mm', n: 'မြန်မာဘာသာ', u: false, t: false },
    { c: 'mn', n: 'Монгол', u: false, t: false },
    { c: 'no', n: 'norsk', u: false, t: false },
    { c: 'pl', n: 'Polskie', u: false, t: false },
    { c: 'pt', n: 'Português', u: false, t: false },
    { c: 'ru', n: 'русский', u: false, t: false },
    { c: 'es', n: 'Español', u: false, t: false },
    { c: 'sv', n: 'svenska', u: false, t: false },
    { c: 'th', n: 'ไทย', u: false, t: false },
    { c: 'tr', n: 'Türk', u: false, t: false },
    { c: 'uk', n: 'Українська', u: false, t: false },
    { c: 'vi', n: 'Tiếng Việt', u: false, t: false },
    { c: 'tl', n: 'Tagalog', u: false, t: false },
    { c: 'kk', n: 'қазақша', u: false, t: false },
    { c: 'cs', n: 'čeština', u: false, t: false },
    { c: 'el', n: 'Ελληνικά', u: false, t: false },
    { c: 'it', n: 'italiano', u: false, t: false },
    { c: 'af', n: 'Afrikaans', u: false, t: false },
    { c: 'fi', n: 'suomi', u: false, t: false },
    { c: 'ar', n: 'اللُّغَةُ الْعَرَبِيَّةُ', u: false, t: false }
  ],
  usable: function () {
    const usableList = this.list.filter(x => x.u).map(x => x.c)
    return usableList
  },
  valueObj: function (val) {
    let obj = {}
    this.list.map(x => {
      obj[x.c] = val || ''
    })
    return obj
  }
}

export default LANG
